import React from "react";
import { titles } from "constants/titles";
import CustomButton from "components/widgets/custom-button/CustomButton";
import { StepIcon } from "assets/SVGs/StepIcon";
import { convertInRequiredTimeZone, checkIsCurrentDate } from "utility";

const StepCounterCard = ({ 
  customSchemaForUI, 
  setShowAddStepGoalModal,
  selectedMedicalUser,
  currentTimeZone
}) => {
  return (
    <div className="dp_step_counter_card">
      <div className="dp_step_content_wrapper">
        <div className="dp_step_status_container">
          <StepIcon className="dp_step_icon" width="24" height="24" />
          <div className="dp_step_text_content">
            <h3 className="dp_step_title">{titles?.step_counter}</h3>
            {customSchemaForUI?.dataTimeStamp ? (
              <div className="dp_step_status">
                <p className="dp_step_status_time">
                  {`Status as of ${convertInRequiredTimeZone(
                    customSchemaForUI?.dataTimeStamp,
                    selectedMedicalUser?.timezone,
                    currentTimeZone
                  )}`}
                </p>
              </div>
            ) : null}
          </div>
        </div>
        <div className="dp_step_value_wrapper">
          <p className="dp_step_count">
            {customSchemaForUI?.stepCounter || "0"}
          </p>
          <p className="dp_step_label">
            {checkIsCurrentDate(customSchemaForUI?.dataTimeStamp)
              ? titles?.today_steps
              : titles?.past_steps}
          </p>
        </div>
      </div>
      <CustomButton
        text={titles?.add_step_goal}
        width="100%"
        className="dp_add_step_goal_button"
        onClick={() => setShowAddStepGoalModal(true)}
      />
    </div>
  );
};

export default StepCounterCard;
